export * from '@hyphengroup/cms-components/components/CarInsurance/WhatsappStickyModule';
